var _path, _path2, _path3, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgGraphicPhoneSmsmin = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10.396 2.332H36.38v36.444H10.396z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.841 0H13.206c-1.368 0-2.68.54-3.647 1.501a5.108 5.108 0 0 0-1.511 3.624v30.75c0 1.36.543 2.663 1.51 3.624A5.176 5.176 0 0 0 13.208 41H33.84c1.368 0 2.68-.54 3.648-1.501a5.108 5.108 0 0 0 1.51-3.624V5.125c0-1.36-.543-2.663-1.51-3.624A5.176 5.176 0 0 0 33.84 0Zm-7.738 38.438h-5.159v-2.563h5.16v2.563Zm7.738-6.407c0 .34-.136.666-.377.906-.242.24-.57.376-.913.376H14.496c-.342 0-.67-.136-.912-.376a1.277 1.277 0 0 1-.377-.906V6.406c0-.34.135-.665.377-.906.242-.24.57-.375.912-.375h18.055c.343 0 .67.135.913.375.241.24.377.566.377.906v25.625Z",
    fill: "#7542E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.3 9.994a2.3 2.3 0 0 0-2.3 2.3v9.392a2.3 2.3 0 0 0 2.3 2.3h14.996l6.641 5.528c.282.234.7-.022.62-.38l-1.17-5.148h2.48a2.3 2.3 0 0 0 2.3-2.3v-9.391a2.3 2.3 0 0 0-2.3-2.3H2.301Z",
    fill: "#054096"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.024,
    y: 13.992,
    width: 19.114,
    height: 1.999,
    rx: 0.999,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.024,
    y: 17.99,
    width: 14.084,
    height: 1.999,
    rx: 0.999,
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGraphicPhoneSmsmin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/graphic_phone_sms.min.ef8be3663ebfd3f90b0157df34fccf1a.svg";